import { SAML_DOMAIN, SSO, SAML_METADATA, AUTH_METHOD_LABELS } from './constants';

export const authMethodsText = (orgAuthMethods: Record<string, boolean>) =>
  Object.entries(orgAuthMethods)
    .filter(([, bool]) => bool)
    .map(([name]) => AUTH_METHOD_LABELS[name as keyof typeof AUTH_METHOD_LABELS])
    .join(' • ');

const omitSSOFields = (values: Record<string, string | boolean>) => {
  /**
   * There is a BE validation that only makes updates to these fields if SSO
   * is enabled, but it doesn't hurt to add a second check here.
   */
  const { [SAML_DOMAIN]: _1, [SAML_METADATA]: _2, ...rest } = values;
  return rest;
};

export const createUpdatePayload = (values: Record<string, string | boolean>) => {
  const ssoEnabled = values[SSO];
  return ssoEnabled ? values : omitSSOFields(values);
};
